import { BaseClient, BaseResponse, fromCustomClient } from 'geotiff';

// Lecture d'un OME-TIFF distant par requêtes HTTP Range, sans passer par le cache HTTP du navigateur.
// Chrome met en file les requêtes simultanées vers une même URL tant que la précédente écrit dans son cache :
// toutes les tuiles d'un fichier partageant l'URL, elles arrivaient une par une (« pending »). Avec
// cache: 'no-store', elles partent en parallèle ; les blocs déjà lus restent en mémoire (cache de geotiff).

class FetchResponse extends BaseResponse {
  constructor(response) {
    super();
    this.response = response;
  }

  get status() {
    return this.response.status;
  }

  getHeader(name) {
    return this.response.headers.get(name);
  }

  async getData() {
    return this.response.arrayBuffer();
  }
}

class NoStoreClient extends BaseClient {
  async request({ headers, signal } = {}) {
    return new FetchResponse(await fetch(this.url, { headers, signal, cache: 'no-store' }));
  }
}

// GeoTIFF à passer à Viv : loadOmeTiff(url, { source: await openRemoteTiff(url) }).
export const openRemoteTiff = url => fromCustomClient(new NoStoreClient(url), { cacheSize: Infinity });
